import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import VueTheMask from 'vue-the-mask'
import VueSocketIO from 'vue-socket.io'
import VueImg from 'v-img';
import VueMapbox from "vue-mapbox";
import Mapbox from "mapbox-gl";
import './css/global.css'

Vue.config.productionTip = false

Vue.use(new VueSocketIO(
    {
      debug: true,
      connection: (process.env.VUE_APP_SERVER_URL)
    } 
  )
)

Vue.use(VueMapbox, { mapboxgl: Mapbox })

Vue.use(VueTheMask)

Vue.use(VueImg)

new Vue({
  vuetify,
  router,
  store,
  
  render: h => h(App)
}).$mount('#app')
